import { forwardRef } from 'react';

import { SvgStyled } from '@sternum/web/icons/icons.styles';
import { IconProps } from '@sternum/web/icons/icons.types';

export interface Check2ColorfulIcon extends IconProps {
  color2?: string;
}

export const Check2ColorfulIcon = forwardRef<SVGSVGElement, Check2ColorfulIcon>(function Check2ColorfulIcon(
  { color = '', color2 = '#E7EFFF', height = 12, width = 12, hasCursorPointer = false, ...props },
  ref,
) {
  return (
    <SvgStyled
      ref={ref}
      fill="none"
      viewBox="0 0 12 12"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      data-has-cursor-pointer={hasCursorPointer}
      {...props}
    >
      <rect x="0.5" y="0.5" width="11" height="11" rx="5.5" fill={color2} />
      <path
        d="M8.63352 4.70383C8.79915 4.52074 8.78701 4.23644 8.60622 4.06851C8.42505 3.90022 8.14337 3.91269 7.9774 4.09617L5.41072 6.93351L4.423 5.84162C4.25702 5.65815 3.97534 5.64568 3.79417 5.81396C3.61338 5.98189 3.60124 6.26619 3.76687 6.44929L5.08266 7.90383C5.16683 7.99688 5.28583 8.05 5.41072 8.05C5.53562 8.05 5.65462 7.99688 5.73878 7.90383L8.63352 4.70383Z"
        fill={color || 'currentColor'}
        stroke={color || 'currentColor'}
        strokeWidth="0.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect x="0.5" y="0.5" width="11" height="11" rx="5.5" stroke={color || 'currentColor'} />
    </SvgStyled>
  );
});
